var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "#18181B",
    stroke: "url(#paint0_linear_2294_1512)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-twitter 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.2009 18.0432C32.5125 18.3492 31.7859 18.5404 31.021 18.6552C31.7859 18.1962 32.3978 17.4696 32.6655 16.59C31.9389 17.0107 31.1357 17.3166 30.2561 17.5078C29.5677 16.7812 28.5734 16.3223 27.5025 16.3223C25.4374 16.3223 23.7546 18.005 23.7546 20.0702C23.7546 20.3761 23.7929 20.6438 23.8694 20.9116C20.7716 20.7586 17.9798 19.2671 16.1058 16.9724C15.7999 17.5461 15.6086 18.158 15.6086 18.8464C15.6086 20.1467 16.2588 21.294 17.2914 21.9824C16.6795 21.9441 16.1058 21.7912 15.5704 21.5235V21.5617C15.5704 23.3974 16.8707 24.9272 18.5917 25.2714C18.2857 25.3479 17.9415 25.3861 17.5973 25.3861C17.3679 25.3861 17.1002 25.3479 16.8707 25.3096C17.3679 26.8011 18.7446 27.9102 20.3891 27.9102C19.0888 28.9046 17.4826 29.5165 15.7234 29.5165C15.4174 29.5165 15.1115 29.5165 14.8438 29.4782C16.5265 30.5491 18.4769 31.161 20.6186 31.161C27.5408 31.161 31.327 25.4244 31.327 20.4526C31.327 20.2997 31.327 20.1084 31.327 19.9555C32.0536 19.4583 32.7037 18.8081 33.2009 18.0432Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2294_1512",
    x1: 0,
    y1: 23,
    x2: 46,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95CE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwit);
export default __webpack_public_path__ + "static/media/twit.0dfa943a2756eb72bd496f1d8b70bfa2.svg";
export { ForwardRef as ReactComponent };